(function($) {
    $(document).ready(function() {
        initSwiper();
    });

    function initSwiper() {
        const gallery = document.querySelector('.product-media-gallery');
        if (!gallery) return;

        const thumbnails = Array.from(gallery.querySelectorAll('.product-media-thumbnail'));
        const thumbnailSwiper = new Swiper(gallery.querySelector('.thumbnail-swiper'), {
            slidesPerView: 1,
            autoHeight: true,
            navigation: {
                nextEl: gallery.querySelector('.swiper-button-next'),
                prevEl: gallery.querySelector('.swiper-button-prev'),
            },
        });

        thumbnails.forEach((thumbnail, index) => {
            thumbnail.addEventListener('click', () => thumbnailSwiper.slideTo(index));
        });

        thumbnailSwiper.on('slideChange', function () {
            const activeIndex = thumbnailSwiper.activeIndex;
            gallery.querySelector('.pagination-count .current-index').textContent = activeIndex + 1;

            thumbnails.forEach((thumbnail, index) => {
                const isActive = index === activeIndex;
                thumbnail.classList.toggle('is-active', isActive);
                thumbnail.setAttribute('aria-current', String(isActive));
            });

            thumbnails[activeIndex]?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        });
    }
})(jQuery);
